import React from "react";
import Index from "../components/tvremote";

function TvRemote() {
	return <Index />;
}

export default TvRemote;
